import React from "react";
import { AppBar, Toolbar, Typography, Box, Avatar, IconButton, Menu, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase/firebaseConfig";

const Header = ({ open, onToggleDrawer }) => {
  const [user] = useAuthState(auth);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleLogout = () => {
    auth.signOut();
    handleMenuClose();
  };

  return (
    <AppBar position="fixed" sx={{ backgroundColor: "#fff", color: "#000", boxShadow: 1, zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box display="flex" alignItems="center">
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={onToggleDrawer}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <img
            src="https://nataonline.com/wp-content/uploads/2024/02/6.jpg"
            alt="Logo"
            style={{ height: 90 }}
          />
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body1">
            Hola, {user?.email || "Invitado"}
          </Typography>
          <IconButton onClick={handleMenuOpen}>
            <Avatar alt={user?.email} src={user?.email} />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;